module.exports = __webpack_public_path__ + "img/poter3.0b54d0d4.jpg";